// React
import React from "react";

// MUI
import { Stack, Typography, Switch } from "@mui/material";

// Components
import { CardInfo, FormikTextField } from "Common/Components";

// Styles
import { textStyles, commonStyles } from "Common/Styles";

// Form Fields
import {
  accuroFields,
  accuroFieldRows,
  accuroOptionalFields,
} from "../Common/fields";

const AccuroPage = ({
  formik,
  clinicProp,
  hasTypeId,
  setHasTypeId,
  viewOnly = false,
}) => {
  const fieldMap = Object.fromEntries(accuroFields.map((f) => [f.id, f]));
  return (
    <>
      <CardInfo
        title="Accuro Information"
        tooltipInfo="Information required to connect to Accuro"
      >
        {!clinicProp &&
          accuroFieldRows.map((row, rowIdx) => (
            <Stack direction="row" alignItems="flex-start" gap={2} key={rowIdx}>
              {row.map((fieldId) => {
                const field = fieldMap[fieldId];
                return (
                  <FormikTextField
                    key={field.id}
                    formik={formik}
                    field={{
                      ...field,
                      ...(viewOnly && { disabled: true, review: true }),
                    }}
                    name={field.id}
                  />
                );
              })}
            </Stack>
          ))}
        <Typography sx={textStyles.subtitle}>Optional Information</Typography>
        <Stack direction="row" alignItems="center" gap={2}>
          <Stack direction="row" sx={{ width: "100%", alignItems: "center" }}>
            <Typography sx={{ ...textStyles.infoText, textAlign: "left" }}>
              If this clinic wants to populate the Type Id field in Accuro for
              online bookings, enable this option and enter the Appointment Type
              ID.
            </Typography>
            <Switch
              checked={hasTypeId}
              onChange={(event) => {
                setHasTypeId(event.target.checked);
                if (!event.target.checked) {
                  formik.setFieldValue("appointmentTypeId", "");
                }
              }}
              sx={commonStyles.terracottaSwitch}
            />
          </Stack>
          {accuroOptionalFields.map((field) => {
            return (
              <FormikTextField
                key={field.id}
                formik={formik}
                field={{
                  ...field,
                  ...(viewOnly && { disabled: true, review: true }),
                }}
                name={field.id}
                disabled={!hasTypeId}
              />
            );
          })}
        </Stack>
      </CardInfo>
    </>
  );
};

export default AccuroPage;
